export default __webpack_public_path__ + "static/media/Ballroll_00228.dd4eea60.png";